// analytics/topMoviesAnalytics.js
//
// My Top Movies is an acquisition feature, so its events go two places:
//   - GA4 via trackEvent (when web analytics is enabled), like every event;
//   - the server funnel log (/top-movies/events), which also counts guests,
//     keyed by an anonymous random visitor id — never by anything personal.
// Page-view-style events are sent once per page load (onceKey) and the
// server de-duplicates them per day, so reloads don't inflate the funnel.
import { ANALYTICS_EVENTS, trackEvent } from './index';
import { TopMoviesService } from '../services/topMoviesService';

const VISITOR_KEY = 'aluvo_visitor_id';

export function getVisitorId() {
    try {
        let id = window.localStorage.getItem(VISITOR_KEY);
        if (!id || !/^[A-Za-z0-9_-]{8,64}$/.test(id)) {
            id = `v_${(window.crypto?.randomUUID?.() || `${Date.now()}${Math.random()}`).replace(/[^A-Za-z0-9]/g, '').slice(0, 32)}`;
            window.localStorage.setItem(VISITOR_KEY, id);
        }
        return id;
    } catch {
        return null;
    }
}

const sentOnce = new Set();

/**
 * @param {string} eventName  one of ANALYTICS_EVENTS.TOP_MOVIES_*
 * @param {object} [properties]  size, ranked, logged_in, channel, format, source, ref, ...
 * @param {{ listSlug?: string, onceKey?: string }} [options]
 */
export function trackTopMovies(eventName, properties = {}, { listSlug = null, onceKey = null } = {}) {
    if (!Object.values(ANALYTICS_EVENTS).includes(eventName)) return;
    if (onceKey) {
        const key = `${eventName}:${onceKey}`;
        if (sentOnce.has(key)) return;
        sentOnce.add(key);
    }
    trackEvent(eventName, { ...properties, platform: 'web', ...(listSlug ? { list_id: listSlug } : {}) });
    TopMoviesService.sendEvents(getVisitorId(), [{ eventType: eventName, listSlug, properties }]);
}

export function __resetTopMoviesAnalyticsForTest() {
    sentOnce.clear();
}
